declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FormOrganizer, SaveOTSectionDataRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, FollicularScanDetailController, FollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, SaveFollicularScanDetailRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleTestDataRequest, SaveIvfCycleMedicineDataRequest, SaveTestMedCycleActivitiesRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, SaveFollicularPickupsDetailV2Request, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest, UpdateIvfCycleByActivityRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, OocyteMaturityByCycleController, OocyteMaturityByCycleRequest, SaveSingleWellFollicleRequest, SaveOocyteMaturityInfoRequest, SaveOocyteMorphologyInfoRequest, SaveIvfOocyteEmbryoStorageRequest, SaveCycleStatusRequest, OocyteMorphologyByCycleController, OocyteMorphologyByCycleRequest, OqaDetails, OocyteAbnormalitiesDetails } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe, OocyteAbPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbEditOvaryModal } from '../ivfworkbench/editovary.modal';
import { NgbAddScanTestModal } from '../ivfworkbench/addscantest.modal';
import { NgbAddScanMedicineModal } from '../ivfworkbench/addscanmedicine.modal';
import { NgbEditScanMedicineModal } from '../ivfworkbench/editscanmedicine.modal';
import { NgbEditScanTestModal } from '../ivfworkbench/editscantest.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { PrintService } from '../../../../services/print.service';
import { NgbSearchProviderModal } from '../ivfworkbench/searchprovider.modal';
import { NgbAddOqaModal } from '../ivfworkbench/addoqa.modal';
import { NgbEditOqaModal } from '../ivfworkbench/editoqa.modal';
import { NgbAddAbnormalOqaModal } from '../ivfworkbench/addabnormaloqa.modal';
import { NgbEditAbnormalOqaModal } from '../ivfworkbench/editabnormaloqa.modal';

@Component({
    selector: 'oqaviewedit',
    templateUrl: './oqaviewedit.modal.html',
    styleUrls: ['./oqaviewedit.modal.scss']
})

export class NgbOqaviewEditModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode:number;
    @Input() TemplateName: string;
    @Input() CycleCode: number;
    @Input() FollicularGrowthCode: number;
    @Input() ActivityCode: number;
    @Input() PatientCode: number;
    @Input() FormattedCode: string;
    @Input() IsShowDetail: boolean = false;
    @Input() SectionSequenceNO: number;
    @Input() SectionTypeCode: number;
    @Input() Date: Date;
    @Input() Sign1: string;
    @Input() Sign2: string;
    @Input() TitleName: string;
    @Input() DOC: number;
    @Input() GradingModel: string;
    @Input() sectionData: SectionData;
    @Input() PatientReportCode: any;
    OvulationTriggerDate: NgbDateStruct;
    public ActivityDate: NgbDateStruct;
    public displayPatientdata: boolean = true;
    public displayscansdata: boolean = false;
    @Input() Eggsourcetype: string;
    public EggSourceType: string;
    ExpiryDate: NgbDateStruct;
    ExpiryDate2: NgbDateStruct;
    OvumPickupdate: NgbDateStruct;
    OvumPlannedPickupDate: NgbDateStruct;
    //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
    @Input() ServiceCode: number;
    searchTitle: string;
    ScanDate: NgbDateStruct;
    NextScanDate: NgbDateStruct;
    public EggSourceActorCode: number;
    public OvulationtriggerDate: Date;
    //private isvisibleendo: boolean = true;
    public ApiResData: ApiResponseModel;
   // public data: string;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    private isvisible: boolean = true;
    public ActivityCodeNew: number;
    private isvisibleendo: boolean = true;
    public ProvidedName: string;
    public ProvidedCode: number;
    public ProvidedNumber: number;
    public ProvidedName2: string;
    public ProvidedCode2: number;
    public ProvidedNumber2: number;
    public Displaynew: boolean = false;
    public Displayold: boolean = true;
    //public IsSelected: boolean;
    ExtractionDate: NgbDateStruct;
    CurrentSaveSingleWellFollicleRequest: SaveSingleWellFollicleRequest;
    CurrentSaveOocyteMaturityInfoRequest: SaveOocyteMaturityInfoRequest;
    CurrentSaveOocyteMorphologyInfoRequest: SaveOocyteMorphologyInfoRequest;
    CurrentSaveIvfOocyteEmbryoStorageRequest: SaveIvfOocyteEmbryoStorageRequest;
    CurrentSaveCycleStatusRequest: SaveCycleStatusRequest;
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    SelectedpatientDetails: TreatmentCyclesByActorCodeController;

    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
       // alert("patientsdetails");
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.SelectedpatientDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                   /// this.LoadDSAData();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
      private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, public printService: PrintService,
      private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
      private tosterservice: NGXToastrService, private spinner: NgxSpinnerService, private parserFormatter: NgbDateParserFormatter, private filter2: OocyteAbPipe,) { }
  ngOnInit() {
   
    this.ShowService = false;
      this.CurrentSaveSingleWellFollicleRequest = new SaveSingleWellFollicleRequest();

      this.CurrentSaveSingleWellFollicleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveOocyteMaturityInfoRequest = new SaveOocyteMaturityInfoRequest();

      this.CurrentSaveOocyteMaturityInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveOocyteMorphologyInfoRequest = new SaveOocyteMorphologyInfoRequest();
      this.CurrentSaveOocyteMorphologyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveIvfOocyteEmbryoStorageRequest = new SaveIvfOocyteEmbryoStorageRequest();
      this.CurrentSaveIvfOocyteEmbryoStorageRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
     this.CurrentSaveCycleStatusRequest = new SaveCycleStatusRequest();

      this.CurrentSaveCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.LoadPatients();
      this.LoadScansData();
      this.LoadOqaData();
      this.LoadMaturityData();
      this.LoadMorphologyData();
      this.LoadMaturityData2();
      this.LoadCycles();
     

      //this.LoadScansData();
      //this.LoadOvaryData();
      
      //this.LoadTestData();
      //this.LoadMedicineData();

  }
    CurrentOocyteQualityAssessmentByCodeController: //Observable<OocyteQualityAssessmentByCodeController>;
        Array<OocyteQualityAssessmentByCodeController>;
    FollicularOocyteInfo: OocyteQualityAssessmentByCodeController;
    CurrentOocyteQualityAssessmentByCodeRequest: OocyteQualityAssessmentByCodeRequest;

    LoadScansData() {
        //alert("ScansData")
        this.CurrentOocyteQualityAssessmentByCodeRequest = new OocyteQualityAssessmentByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentOocyteQualityAssessmentByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetOocyteQualityAssessmentByCodeController();
    }

    AddRow() {
        if (this.CurrentOocyteQualityAssessmentByCodeController == null) {
            this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
        }
        if (this.CurrentOocyteQualityAssessmentByCodeController != null) {

            var row = new OocyteQualityAssessmentByCodeController();
            row.WellNo = this.CurrentOocyteQualityAssessmentByCodeController.length + 1;
            row.GroupId = "";
            row.EmbryoId = "";
            row.SingleWellFollicleCoder = 0;
            this.CurrentOocyteQualityAssessmentByCodeController.push(row);
            this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');
            //this.CurrentOocyteQualityAssessmentByCodeController.po
        }

    }
    GetOocyteQualityAssessmentByCodeController() {
        // this.StartRefreshing();

        this.CurrentOocyteQualityAssessmentByCodeRequest.SingleWellFollicleCode = this.CycleCode;
        this.CurrentOocyteQualityAssessmentByCodeRequest.ConditionalOperator = 10;

        //alert(this.FormattedCode);
        this.actorservice.GetOocyteQualityAssessmentByCodeController(this.CurrentOocyteQualityAssessmentByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentOocyteQualityAssessmentByCodeController = this.ApiResData.Result;
                    //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
                    //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

                    //data.forEach((v, i, a) => {
                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
                    //});
                    //for (let index = 0; index < data.length; index++){
                    //    //alert(data[index].SingleWellFollicleCoder);

                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
                    //}
                    //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //   alert(this.FollicularOocyteInfo.TreatmentCycle);
                    //if (this.FollicularScanEndInfo.ScanDate != null) {
                    //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
                    //  if (SValidFrom.getFullYear() > 1900) {
                    //    console.log('this.UpdateDate >1990');
                    //    this.ScanDate = {

                    //      year: SValidFrom.getFullYear(),
                    //      month: SValidFrom.getMonth() + 1,
                    //      day: SValidFrom.getDate()
                    //    }
                    //  }
                    //}
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentIvfOocyteEmbryoStorageByCodeController: Array<IvfOocyteEmbryoStorageByCodeController>;
    CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;

    LoadOqaData() {
        //alert("ScansData")
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfOocyteEmbryoStorageByCodeController();
    }

    GetIvfOocyteEmbryoStorageByCodeController() {
        //this.StartRefreshing();

        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.ActorCode;

        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 10;

        //alert(this.FormattedCode);
        this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;

                    if (this.CurrentIvfOocyteEmbryoStorageByCodeController != null ||
                        this.CurrentIvfOocyteEmbryoStorageByCodeController.length > 0) {

                        this.OocyteStoreItems = new Array<OocyteStoreItem>();
                        this.CurrentIvfOocyteEmbryoStorageByCodeController.forEach((v, i, d) => {
                            var item = new OocyteStoreItem();
                            item.IsSelected = false;
                            item.Morphology = v.Morphology;
                            item.OocyteEmbryoStorageCode = v.OocyteEmbryoStorageCode;
                            item.Status = v.Status;
                            item.StorageUnitType = v.StorageUnitType;
                            item.StorageUnitDetails = v.StorageUnitDetails;
                            item.WellNo = v.WellNo;
                            this.OocyteStoreItems.push(item);
                        });

                    }

                    //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
                    //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

                    //data.forEach((v, i, a) => {
                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
                    //});
                    //for (let index = 0; index < data.length; index++){
                    //    //alert(data[index].SingleWellFollicleCoder);

                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
                    //}
                    //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //   alert(this.FollicularOocyteInfo.TreatmentCycle);
                    //if (this.FollicularScanEndInfo.ScanDate != null) {
                    //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
                    //  if (SValidFrom.getFullYear() > 1900) {
                    //    console.log('this.UpdateDate >1990');
                    //    this.ScanDate = {

                    //      year: SValidFrom.getFullYear(),
                    //      month: SValidFrom.getMonth() + 1,
                    //      day: SValidFrom.getDate()
                    //    }
                    //  }
                    //}
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //this.LoadCycles();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    OocyteStoreItems: Array<OocyteStoreItem>;
    Store() {
        //alert(new);
        var toFreeze = this.CurrentOocyteQualityAssessmentByCodeController.filter(function (v, i, d) {
            return v.IsFrozen == true
        });

        if (this.CurrentIvfOocyteEmbryoStorageByCodeController == null ||
            this.CurrentIvfOocyteEmbryoStorageByCodeController.length == 0) {

            this.OocyteStoreItems = new Array<OocyteStoreItem>();
            toFreeze.forEach((v, i, d) => {
                var item = new OocyteStoreItem();
                item.IsSelected = false;
                item.Morphology = v.Morphology;
                item.OocyteEmbryoStorageCode = 0;
                item.WellNo = v.WellNo;
                this.OocyteStoreItems.push(item);
            });

        }
    }


    onSubmit2(data2: OocyteStoreItem) {


        if (data2.OocyteEmbryoStorageCode == 0) {
            this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 10;
        }
        else {
            this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 20;
        }
        //  this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 10;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.ActorCode = this.SelectedpatientDetails.EggActorCode;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.ItemType = "OOCYTE";
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.LastUpdateDate = new Date();
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.LastUpdateTime = new Date();
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.Morphology = data2.Morphology;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.OocyteEmbryoStorageCode = data2.OocyteEmbryoStorageCode;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.Status = "FROZEN";
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.StorageUnitDetails = data2.StorageUnitDetails;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.StorageUnitType = data2.StorageUnitType;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.TreatmentCycle = this.CycleCode;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.Grade = "";

        this.CurrentSaveIvfOocyteEmbryoStorageRequest.WellNo = data2.WellNo;


        this.actorservice.SaveIvfOocyteEmbryoStorage(this.CurrentSaveIvfOocyteEmbryoStorageRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        //this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        //this.LoadInsemination();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );


    }
    onSubmit(data: OocyteQualityAssessmentByCodeController) {

        this.CurrentSaveSingleWellFollicleRequest.WellNo = data.WellNo;
        this.CurrentSaveSingleWellFollicleRequest.OocyteQualityPost = data.OocyteQualityPost;
        this.CurrentSaveSingleWellFollicleRequest.OocyteQualityPre = data.OocyteQualityPre;
        this.CurrentSaveSingleWellFollicleRequest.IsFrozen = data.IsFrozen;
        this.CurrentSaveSingleWellFollicleRequest.IsDiscarded = data.IsDiscarded;
        this.CurrentSaveSingleWellFollicleRequest.Morphology = data.Morphology;
        this.CurrentSaveSingleWellFollicleRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveSingleWellFollicleRequest.SingleWellFollicleCode = data.SingleWellFollicleCoder;
        this.CurrentSaveSingleWellFollicleRequest.GroupId = data.GroupId;
        this.CurrentSaveSingleWellFollicleRequest.EmbryoId = data.EmbryoId;

        if (data.SingleWellFollicleCoder == 0)
            this.CurrentSaveSingleWellFollicleRequest.ConditionalOperator = 1;
        else
            this.CurrentSaveSingleWellFollicleRequest.ConditionalOperator = 1;

        this.actorservice.SaveSingleWellFollicle(this.CurrentSaveSingleWellFollicleRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        //this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );


    }
    delwell(l: any) {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            buttonsStyling: false
        }).then(() => {



            this.DeleteActorIdentitiesWell(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    DeleteActorIdentitiesWell(l: any) {
        var item2 = l as OocyteQualityAssessmentByCodeController;

        console.log('..................');
        // this.StartRefreshing();
        this.CurrentSaveSingleWellFollicleRequest.ConditionalOperator = 3;

        this.CurrentSaveSingleWellFollicleRequest.WellNo = item2.WellNo;
        this.CurrentSaveSingleWellFollicleRequest.OocyteQualityPost = item2.OocyteQualityPost;
        this.CurrentSaveSingleWellFollicleRequest.OocyteQualityPre = item2.OocyteQualityPre;
        this.CurrentSaveSingleWellFollicleRequest.IsFrozen = item2.IsFrozen;
        this.CurrentSaveSingleWellFollicleRequest.IsDiscarded = item2.IsDiscarded;
        this.CurrentSaveSingleWellFollicleRequest.Morphology = item2.Morphology;
        this.CurrentSaveSingleWellFollicleRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveSingleWellFollicleRequest.SingleWellFollicleCode = item2.SingleWellFollicleCoder;

        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveSingleWellFollicle(this.CurrentSaveSingleWellFollicleRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        //this.ShowList = true;
                        this.LoadScansData();

                        //  this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }

    Assessment() {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            allowOutsideClick: false,
            buttonsStyling: false
        }).then(() => {

            this.IsAssessmentCompeted();

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    IsAssessmentCompeted() {


        console.log('..................');
        // this.StartRefreshing();
        this.CurrentSaveCycleStatusRequest.ConditionalOperator = 30;

        this.CurrentSaveCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveCycleStatusRequest.ActivityName = "Oocyte Assessment";
        this.CurrentSaveCycleStatusRequest.ActivityStatus = "Completed";
        this.CurrentSaveCycleStatusRequest.Remarks = "None";
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveCycleStatus(this.CurrentSaveCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.LoadCycles();
                        //this.LoadScansData();
                        //this.LoadOvaryData();
                        //this.LoadTestData();
                        //this.LoadMedicineData();
                        //this.ShowList = true;
                        //this.LoadMedicineData();

                        //this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
   
   
    
    CurrentOocyteMaturityByCycleController: OocyteMaturityByCycleController[];
    //DenudationInfo: OocyteMaturityByCycleController;
    CurrentOocyteMaturityByCycleRequest: OocyteMaturityByCycleRequest;

    LoadMaturityData() {
        //alert("ScansData")
        this.CurrentOocyteMaturityByCycleRequest = new OocyteMaturityByCycleRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentOocyteMaturityByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetOocyteMaturityByCycleController();
    }
    //AddRowMaturity() {
    //  if (this.CurrentOocyteMaturityByCycleController == null) {
    //    this.CurrentOocyteMaturityByCycleController = new Array<OocyteMaturityByCycleController>();
    //  }
    //  if (this.CurrentOocyteMaturityByCycleController != null) {

    //    var row = new OocyteMaturityByCycleController();

    //    row.MaturityLevel = "";
    //    row.OccCount = 0;
    //    row.DenudedCount = 0;
    //    this.CurrentOocyteMaturityByCycleController.push(row);
    //    this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');

    //  }

    //}
    GetOocyteMaturityByCycleController() {

        this.CurrentOocyteMaturityByCycleRequest.ConditionalOperator = 10;
        this.CurrentOocyteMaturityByCycleRequest.CycleCode = this.CycleCode;


        this.actorservice.GetOocyteMaturityByCycleController(this.CurrentOocyteMaturityByCycleRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentOocyteMaturityByCycleController = this.ApiResData.Result;
                    //this.DenudationInfo = this.CurrentOocyteMaturityByCycleController[0];

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentOocyteMaturityByCycleController2: OocyteMaturityByCycleController[];
    DenudationInfo: OocyteMaturityByCycleController;
    CurrentOocyteMaturityByCycleRequest2: OocyteMaturityByCycleRequest;

    LoadMaturityData2() {
        //alert("ScansData")
        this.CurrentOocyteMaturityByCycleRequest2 = new OocyteMaturityByCycleRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentOocyteMaturityByCycleRequest2.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetOocyteMaturityByCycleController2();
    }

    GetOocyteMaturityByCycleController2() {

        this.CurrentOocyteMaturityByCycleRequest2.ConditionalOperator = 15;
        this.CurrentOocyteMaturityByCycleRequest2.CycleCode = this.CycleCode;


        this.actorservice.GetOocyteMaturityByCycleController(this.CurrentOocyteMaturityByCycleRequest2)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentOocyteMaturityByCycleController2 = this.ApiResData.Result;
                    this.DenudationInfo = this.CurrentOocyteMaturityByCycleController2[0];

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentOocyteMorphologyByCycleController: OocyteMorphologyByCycleController[];
    CurrentOocyteMorphologyByCycleRequest: OocyteMorphologyByCycleRequest;

    LoadMorphologyData() {
        //alert("ScansData")
        this.CurrentOocyteMorphologyByCycleRequest = new OocyteMorphologyByCycleRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentOocyteMorphologyByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetOocyteMorphologyByCycleController();
    }

    GetOocyteMorphologyByCycleController() {
        // this.StartRefreshing();
        this.CurrentOocyteMorphologyByCycleRequest.ConditionalOperator = 10;
        this.CurrentOocyteMorphologyByCycleRequest.CycleCode = this.CycleCode;

        //alert(this.FormattedCode);
        this.actorservice.GetOocyteMorphologyByCycleController(this.CurrentOocyteMorphologyByCycleRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentOocyteMorphologyByCycleController = this.ApiResData.Result;

                    this.pdata2 = this.CurrentOocyteMorphologyByCycleController;
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }


    AddOqa() {
        const modalRef = this.modalService.open(NgbAddOqaModal,
            {
                centered: true,
                keyboard: false,
                backdrop: 'static'

            })
        modalRef.componentInstance.CycleCode = this.CycleCode;

        modalRef.result.then(x => { this.GetOocyteMaturityByCycleController() })
    }
    EditOqa(l: OocyteMaturityByCycleController) {
        this.CurrentSaveOocyteMaturityInfoRequest.ConditionalOperator = 20;
        this.CurrentSaveOocyteMaturityInfoRequest.CycleCode = this.CycleCode;
        this.CurrentSaveOocyteMaturityInfoRequest.DenudedCount = l.DenudedCount;
        this.CurrentSaveOocyteMaturityInfoRequest.MaturityLevel = l.MaturityLevel;
        this.CurrentSaveOocyteMaturityInfoRequest.OccCount = l.OccCount;
        this.CurrentSaveOocyteMaturityInfoRequest.CycleOocyteQualityCode = l.OocyteQualityCode;
        const modalRef = this.modalService.open(NgbEditOqaModal,
            {
                centered: true,
                keyboard: false,
                backdrop: 'static'

            })
        modalRef.componentInstance.CurrentSaveOocyteMaturityInfoRequest = this.CurrentSaveOocyteMaturityInfoRequest;
        modalRef.result.then(x => { this.GetOocyteMaturityByCycleController() })
    }
    OnSubmitOqanew() {
        this.spinner.show();
        // this.CurrentSaveOocyteMaturityInfoRequest.DenudationBy = this.DenudationInfo.DenudationBy;
        //this.CurrentSaveOocyteMaturityInfoRequest.ConditionalOperator = 20;
        this.CurrentSaveOocyteMaturityInfoRequest.CycleCode = this.CycleCode;
        this.CurrentSaveOocyteMaturityInfoRequest.OqaData = new Array<OqaDetails>();
        this.CurrentOocyteMaturityByCycleController.forEach((v, i, a) => {
            var item: OqaDetails = new OqaDetails();
            item.CycleOocyteQualityCode = v.OocyteQualityCode;
            item.DenudedCount = v.DenudedCount;
            item.MaturityLevel = v.MaturityLevel;
            item.OccCount = v.OccCount;
            this.CurrentSaveOocyteMaturityInfoRequest.OqaData.push(item);
        });
        //this.CurrentSaveOocyteMaturityInfoRequest.RecordStatus = this.DenudationInfo.;

        this.CurrentSaveOocyteMaturityInfoRequest.ConditionalOperator = 20;
        this.actorservice.SaveOocyteMaturityInfo(this.CurrentSaveOocyteMaturityInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        this.LoadMaturityData();
                        //this.isvisibleendo = true;
                        //this.activeModal.close();
                        //this.clearData();
                        //this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );
    }
    OnSubmitOqaanormailites() {
        this.spinner.show();
        // this.CurrentSaveOocyteMaturityInfoRequest.DenudationBy = this.DenudationInfo.DenudationBy;
        //this.CurrentSaveOocyteMaturityInfoRequest.ConditionalOperator = 20;
        this.CurrentSaveOocyteMorphologyInfoRequest.CycleCode = this.CycleCode;
        this.CurrentSaveOocyteMorphologyInfoRequest.OocyteAbnormalitiesData = new Array<OocyteAbnormalitiesDetails>();
        this.CurrentOocyteMorphologyByCycleController.forEach((v, i, a) => {
            var itemab: OocyteAbnormalitiesDetails = new OocyteAbnormalitiesDetails();
            itemab.CycleOocyteMorphologyCode = v.OocyteMorphologyCode;
            itemab.Morphology = v.Morphology;
            itemab.OocyteCount = v.OocyteCount;
            //item.OccCount = v.OccCount;
            this.CurrentSaveOocyteMorphologyInfoRequest.OocyteAbnormalitiesData.push(itemab);
        });
        //this.CurrentSaveOocyteMaturityInfoRequest.RecordStatus = this.DenudationInfo.;

        this.CurrentSaveOocyteMorphologyInfoRequest.ConditionalOperator = 20;
        this.actorservice.SaveOocyteMorphologyInfo(this.CurrentSaveOocyteMorphologyInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        this.LoadMorphologyData();
                        //this.isvisibleendo = true;
                        //this.activeModal.close();
                        //this.clearData();
                        //this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );
    } AddAbnormalOqa() {
        const modalRef = this.modalService.open(NgbAddAbnormalOqaModal,
            {
                centered: true,
                keyboard: false,
                backdrop: 'static'

            })
        modalRef.componentInstance.CycleCode = this.CycleCode;
        modalRef.result.then(x => { this.GetOocyteMorphologyByCycleController() })
    }
    EditAbnormalOqa(datanormal: OocyteMorphologyByCycleController) {
        this.CurrentSaveOocyteMorphologyInfoRequest.CycleCode = this.CycleCode;
        this.CurrentSaveOocyteMorphologyInfoRequest.Morphology = datanormal.Morphology;
        this.CurrentSaveOocyteMorphologyInfoRequest.OocyteCount = datanormal.OocyteCount;
        this.CurrentSaveOocyteMorphologyInfoRequest.CycleOocyteMorphologyCode = datanormal.OocyteMorphologyCode;
        this.CurrentSaveOocyteMorphologyInfoRequest.ConditionalOperator = 20;
        const modalRef = this.modalService.open(NgbEditAbnormalOqaModal,
            {
                centered: true,
                keyboard: false,
                backdrop: 'static'

            })
        modalRef.componentInstance.CurrentSaveOocyteMorphologyInfoRequest = this.CurrentSaveOocyteMorphologyInfoRequest;
        modalRef.result.then(x => { this.GetOocyteMorphologyByCycleController() })
    }
    ProvidedSelection() {
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.IsShowProvieded = true;
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.ProvidedName = receivedEntry.make;
            this.ProvidedCode = receivedEntry.value;
            this.ProvidedNumber = receivedEntry.number;
            //alert(this.ProvidedName);
        })
    }
    ProvidedSelection2() {
        this.Displaynew = true;
        this.Displayold = false;
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.IsShowDoctor = true;
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.ProvidedName2 = receivedEntry.make;
            this.ProvidedCode2 = receivedEntry.value;
            this.ProvidedNumber2 = receivedEntry.number;
            //this.CurrentSaveOocyteMaturityInfoRequest.PrescribedBy = this.ProviderCode2;
            //this.CurrentSaveOocyteMaturityInfoRequest.DenudationBy = this.ProvidedName2;

            //alert(this.ProviderName);
        })
    }
    onSubmit3() {
        //this.isvisibleendo = false;
        this.spinner.show();
        // this.CurrentSaveOocyteMaturityInfoRequest.DenudationBy = this.DenudationInfo.DenudationBy;
        this.CurrentSaveOocyteMaturityInfoRequest.CycleCode = this.DenudationInfo.TreatmentCycle;
        this.CurrentSaveOocyteMaturityInfoRequest.CycleOocyteQualityCode = this.DenudationInfo.OocyteQualityCode;
        this.CurrentSaveOocyteMaturityInfoRequest.MaturityLevel = this.DenudationInfo.MaturityLevel;
        this.CurrentSaveOocyteMaturityInfoRequest.OccCount = this.DenudationInfo.OccCount;
        this.CurrentSaveOocyteMaturityInfoRequest.DenudedCount = this.DenudationInfo.DenudedCount;
        this.CurrentSaveOocyteMaturityInfoRequest.DenudedByActor = this.DenudationInfo.DenudedByActor;
        //this.CurrentSaveOocyteMaturityInfoRequest.RecordStatus = this.DenudationInfo.;

        this.CurrentSaveOocyteMaturityInfoRequest.ConditionalOperator = 15;
        this.actorservice.SaveOocyteMaturityInfo(this.CurrentSaveOocyteMaturityInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        //this.isvisibleendo = true;
                        //this.activeModal.close();
                        //this.clearData();
                        //this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );


    }

    CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
    OocyteData: TreatmentCycleStatusController[];
    OocyteData2: TreatmentCycleStatusController;
    CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
    LoadCycles() {
        this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetTreatmentCycleStatusController();
    }

    GetTreatmentCycleStatusController() {
        // this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
        //this.spinner.show();
        this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
                    this.OocyteData = this.ApiResData.Result;
                    var Oocytelist = this.OocyteData.filter(
                        function (e) {
                            return e.PhaseActivity == "Oocyte Assessment";
                        });
                    this.OocyteData = Oocytelist;
                    this.OocyteData2 = this.OocyteData[0];
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();
                    this.LoadDSAData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    
    CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
    DSADetails: DSAActivityByCycleCodeController;
    CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

    LoadDSAData() {
       //alert("ScansData")
        this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDSAActivityByCycleCodeController();
    }

    GetDSAActivityByCycleCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
        //this.EggSourceType = this.SelectedpatientDetails.EggSourceType;
        this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.ActorCode;//this.GetActorCode(this.Eggsourcetype);
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
                    this.DSADetails = this.GetCycleActivity2(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
                    //alert(this.DSADetails);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

                    //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
                    //var list = this.CurrentDSAActivityByCycleCodeController.filter(


                    //    function (a) {
                    //        var Date = this.FollicularScanEndInfo.ScanDate;
                    //        var ActorCode = this.SelectedpatientDetails.ActorID;
                    //        return a.ActivityDate == Date && a.ActorCode == ActorCode
                    //    });

                    //this.CurrentDSAActivityByCycleCodeController = list;
                    //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
                    //alert(this.Doc1);
                    //alert(this.Antag);
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    //    GetDsADetails(ActorCode: number, Date: Date) {


    //}
    GetCycleActivity2(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentDSAActivityByCycleCodeController.filter(
            function (v, i, d) {

                return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
            }
        )

    }
    GetActorCode(EggSourceType: string): number {
        // alert("new");
        if (EggSourceType == 'Donor') {
            var DonorActorCode = this.SelectedpatientDetails.EggActorCode;
            return DonorActorCode;
        }
        else if (EggSourceType == 'Self') {
            var OwnerActorCode = this.SelectedpatientDetails.EggActorCode;
            return OwnerActorCode;
        }
    }
    CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
    ActivityCodeInfo: TreatmentCycleActiityMasterController;
    CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

    LoadMasterReq() {
        //alert("ScansData")
        this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCycleActiityMasterController();
    }

    GetTreatmentCycleActiityMasterController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
        //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;
                    
                    this.LoadTestData();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.GetCycleActivity(this.ActorCode, this.ScanDate);

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): TreatmentCycleActiityMasterController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentTreatmentCycleActiityMasterController.filter(
            function (v, i, d) {

                return v.ActorID == ReceipientActorCode && v.DocDate == TransferDateNew;
            }
        )

    }
    CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
    CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

    LoadTestData() {
        //alert("Data")
        this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleTestByCodeController();
    }

    GetIvfCycleTestByCodeController() {
        // this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.CycleCode;
        this.CurrentIvfCycleTestByCodeRequest.ActorCode = 0;
        this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 20;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.EggSourceActorCode = this.ActorCode;
        //alert(this.EggSourceActorCode);
        this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.GetCycleActivity(this.EggSourceActorCode, this.OvulationtriggerDate)[0].CycleActivityCode;
        this.ActivityCodeNew = this.CurrentIvfCycleTestByCodeRequest.ActivityCode;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;

                  
                    this.LoadMedicineData();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentIvfCycleMedicineByCodeController: IvfCycleMedicineByCodeController[];
    CurrentIvfCycleMedicineByCodeRequest: IvfCycleMedicineByCodeRequest;

    LoadMedicineData() {
        //alert("ScansData")
        this.CurrentIvfCycleMedicineByCodeRequest = new IvfCycleMedicineByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleMedicineByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleMedicineByCodeController();
    }

    GetIvfCycleMedicineByCodeController() {
        // this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.CycleCode;
        this.CurrentIvfCycleMedicineByCodeRequest.ConditionalOperator = 20;
        this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.GetCycleActivity(this.EggSourceActorCode, this.OvulationtriggerDate)[0].CycleActivityCode;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleMedicineByCodeController(this.CurrentIvfCycleMedicineByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleMedicineByCodeController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    this.spinner.hide();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
   
       
   
    
    ProviderName: string
    SelectSurgeon() {
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.ProviderName = receivedEntry;
            //alert(this.ProviderName);
        })
    }
    onAssignedToActorCodesurgeon(event: any) {

        //alert(event);
        if (event != null) {

            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            // this.CurrentSaveOocyteMaturityInfoRequest.DenudedByActor = event;
            this.CurrentSaveOocyteMaturityInfoRequest.DenudationBy = event;

            // console.log('event--_>' + event);
            //   }
        }

    }
    pdata2: any[];// = this.data;
    listFilter2: string;
    ngOnChanges2(changes: any) {
        if (JSON.stringify(changes).indexOf("data") != -1)
            this.pdata2 = this.CurrentOocyteMorphologyByCycleController;

        this.criteriaChange2(this.listFilter2);
    }
    criteriaChange2(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter2 = value;
                //alert(this.listFilter);
                this.pdata2 = this.filter2.transform(this.CurrentOocyteMorphologyByCycleController,
                    this.listFilter2);
            }
        }
    }
    BackToPatientdata() {
        this.displayPatientdata = true;
        this.displayscansdata = false;
    }
    BackTodashboard2() {
        //this.Showivf = true;
        //this.Showscan = false;
        this.router.navigate(['healins/ivfworkbench']);
    }
    printoocyte() {
        this.printService.printDocument("oocytequality",
            {
                Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
                TreatmentCycleCodedata: this.SelectedpatientDetails.Code, ActorCodedata: this.SelectedpatientDetails.EggActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate, Sign1Name: this.SelectedpatientDetails.EmbryologistSign,
            }
        );
    }
    printoocytedroplet() {
        this.printService.printDocument("oocytequalitydroplet",
            {
                Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
                TreatmentCycleCodedata: this.SelectedpatientDetails.Code, ActorCodedata: this.SelectedpatientDetails.EggActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate, Sign1Name: this.SelectedpatientDetails.EmbryologistSign,
            }
        );
    }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }

  



}
export class OocyteStoreItem {

    public OocyteEmbryoStorageCode: number;

    public WellNo: number;
    public StorageUnitType: string;
    public StorageUnitDetails: string;
    public Status: string;

    public Morphology: string;

    public IsSelected: boolean;
}
